import { render, staticRenderFns } from "./MaterialColourList.vue?vue&type=template&id=66767911&scoped=true"
import script from "./MaterialColourList.vue?vue&type=script&lang=js"
export * from "./MaterialColourList.vue?vue&type=script&lang=js"
import style0 from "./MaterialColourList.vue?vue&type=style&index=0&id=66767911&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66767911",
  null
  
)

export default component.exports